if (typeof DynaCore_FormConfig_Grid == 'undefined') {
    var DynaCore_FormConfig_Grid =
    {
        partClass: 'el-grid',
        partName: 'grid',
        partSelector: '.el-grid',

        /**
         * Inicializace objektu typu Grid
         */
        init: function () {
            DynaCore_FormConfig_Grid.contextMenuInit();
            DynaCore_FormConfig_Grid.contextMenuInitFields();
            DynaCore_FormConfig_Grid.sortableInit();
        },

        contextMenuInit: function () {
            var designer = $('#designer');
            designer
                .off('contextmenu', DynaCore_FormConfig_Grid.partSelector)
                .on('contextmenu', DynaCore_FormConfig_Grid.partSelector, function (e) {
                    DynaCore_FormConfig_Grid.contextMenuShow(e, this);
                    return false;
                });
        },

        contextMenuInitFields: function () {
            $('#designer').find('.el-grid').each(function (i, elementPart) {
                var partId = $(elementPart).data('part-id');
                var elementFieldGridContainer = $(elementPart).find('.el-grid-fieldGrid-container');
                var elementFieldModalContainer = $(elementPart).find('.el-grid-fieldModal-container');
                var elementFieldSectionContainer = $(elementPart).find('.el-grid-fieldSection-container');

                DynaCore_FormConfig.fieldsInitContextMenuInline(elementFieldGridContainer, 'grids', partId, 'fieldsGrid');
                DynaCore_FormConfig.fieldsInitContextMenuInline(elementFieldModalContainer, 'grids', partId, 'fieldsModal');
                DynaCore_FormConfig.fieldsInitContextMenuInline(elementFieldSectionContainer, 'grids', partId, 'fieldsSection');
            });
        },

        /**
         * Inicializace kontextoveho menu objektu typu Grid
         *
         * @param e
         * @param element
         */
        contextMenuShow: function (e, element) {
            DynaBase_ContextMenu.addHeader(translate('Grid'));

            // Upravit
            DynaBase_ContextMenu.addButton(translate('Edit'), 'pencil', function () {
                DynaCore_FormConfig_Grid.edit(element);
            });

            DynaBase_ContextMenu.addDivider();
            DynaBase_ContextMenu.addHeader(translate('General'));

            // Vlastnosti
            DynaBase_ContextMenu.addButton(translate('Properties'), 'toggle-on', function () {
                var storageId = $(element).data('part-id');

                DynaCore_FormConfig_Properties.edit(element, DynaCore_FormConfig_Grid.partName + 's', storageId);
            });

            // Nastaveni
            DynaBase_ContextMenu.addButton(translate('Settings'), 'cog', function () {
                var storageId = $(element).data('part-id');

                DynaCore_FormConfig_Settings.edit(element, DynaCore_FormConfig_Grid.partName + 's', storageId);
            });

            // Odstranit
            DynaBase_ContextMenu.addButton(translate('Remove'), 'trash', function () {
                DynaCore_FormConfig_Grid.delete(element);
            });

            // Sestaveni
            DynaBase_ContextMenu.build(e, element);
        },

        /**
         * Inicializace razeni objektu typu Grid
         */
        sortableInit: function () {
            var indexPartOld = 0;
            var indexPartNew = 0;

            $(".el-col").sortable({
                axis: 'y',
                items: DynaCore_FormConfig_Grid.partSelector,
                start: function (e, ui) {

                    // Najdeme si element rodice
                    var parentElement;
                    var cardElement = $(e.target).children('.card');
                    if ($(cardElement).length > 0) {
                        parentElement = $(cardElement).children('.card-body');
                    } else {
                        parentElement = e.target;
                    }

                    // Najdeme index
                    $(parentElement).find(DynaCore_FormConfig_Grid.partSelector).each(function (i, el) {
                        if ($(el).is(ui.item)) {
                            indexPartOld = i;
                        }
                    });
                },
                update: function (e, ui) {

                    // Najdeme si element rodice
                    var parentElement = null;
                    var cardElement = $(e.target).children('.card');
                    if ($(cardElement).length > 0) {
                        parentElement = $(cardElement).children('.card-body');
                    } else {
                        parentElement = e.target;
                    }

                    // Najdeme index
                    $(parentElement).find(DynaCore_FormConfig_Grid.partSelector).each(function (i, el) {
                        if ($(el).is(ui.item)) {
                            indexPartNew = i;
                        }
                    });

                    if (parseInt($(ui.item).data('tab')) >= 0) {
                        data = {
                            _ch: $('#_ch').val(),
                            pa: DynaCore_FormConfig_Grid.partName,
                            r: $(ui.item).data('row'),
                            c: $(ui.item).data('col'),
                            t: $(ui.item).data('tab'),
                            tr: $(ui.item).data('tab-row'),
                            tc: $(ui.item).data('tab-col'),
                            o: indexPartOld,
                            n: indexPartNew
                        };
                    } else {
                        data = {
                            _ch: $('#_ch').val(),
                            pa: DynaCore_FormConfig_Grid.partName,
                            r: $(ui.item).data('row'),
                            c: $(ui.item).data('col'),
                            o: indexPartOld,
                            n: indexPartNew
                        };
                    }

                    $.ajax({
                        type: 'get',
                        url: window.location.href.replace('/form-config/', '/form-config/part-sort/'),
                        data: data,
                        dataType: "json",
                        success: function () {
                            DynaCore_FormConfig.reindex();
                        }
                    });
                }
            });
        },

        /**
         * Pridani objektu typu Grid
         *
         * @param element
         * @param elementParent
         * @returns {boolean}
         */
        add: function (element, elementParent) {
            var indexRow = $(elementParent).data('row');
            var indexCol = $(elementParent).data('col');
            var indexTab = $(elementParent).data('tab');
            var indexTabRow = $(elementParent).data('tab-row');
            var indexTabCol = $(elementParent).data('tab-col');
            var hasCard = $(elementParent).children().hasClass('el-col-card');

            if (true == hasCard) {
                elementParent = $(elementParent).children('.el-col-card').children('.card-body');
            }

            var partIndex = $(elementParent).children(DynaCore_FormConfig_Grid.partSelector).length;

            $.ajax({
                type: 'get',
                url: window.location.href.replace('/form-config/', '/form-config/part-add/'),
                data: {
                    _ch: $('#_ch').val(),
                    pa: DynaCore_FormConfig_Grid.partName,
                    r: indexRow,
                    c: indexCol,
                    t: indexTab,
                    tr: indexTabRow,
                    tc: indexTabCol,
                    paIn: partIndex
                },
                dataType: "json",
                success: function (data) {
                    var html = '';

                    if (parseInt($(elementParent).data('tab-row')) >= 0) {
                        html += '<div class="el ' + DynaCore_FormConfig_Grid.partClass + '" data-row="' + indexRow + '" data-col="' + indexCol + '" data-tab="' + indexTab + '" data-tab-row="' + indexTabRow + '" data-tab-col="' + indexTabCol + '" data-part-index="' + data.paIn + '" data-part-id="' + data.paId + '">';
                        html += '    <span class="description">' + translate('Grid') + '</span>';
                        html += '    <ul class="el-' + DynaCore_FormConfig_Grid.partName + '-fieldGrid-container list-unstyled"></ul>';
                        html += '    <ul class="el-' + DynaCore_FormConfig_Grid.partName + '-fieldModal-container list-unstyled"></ul>';
                        html += '    <ul class="el-' + DynaCore_FormConfig_Grid.partName + '-fieldSection-container list-unstyled"></ul>';
                        html += '</div>';
                    } else {
                        html += '<div class="el ' + DynaCore_FormConfig_Grid.partClass + '" data-row="' + indexRow + '" data-col="' + indexCol + '" data-part-index="' + data.paIn + '" data-part-id="' + data.paId + '">';
                        html += '    <span class="description">' + translate('Grid') + '</span>';
                        html += '    <ul class="el-' + DynaCore_FormConfig_Grid.partName + '-fieldGrid-container list-unstyled"></ul>';
                        html += '    <ul class="el-' + DynaCore_FormConfig_Grid.partName + '-fieldModal-container list-unstyled"></ul>';
                        html += '    <ul class="el-' + DynaCore_FormConfig_Grid.partName + '-fieldSection-container list-unstyled"></ul>';
                        html += '</div>';
                    }

                    $(elementParent).append(html);

                    DynaCore_FormConfig.init();
                    DynaBase_Tabs.init();
                }
            });
        },

        /**
         * Upraveni objektu typu Grid
         *
         * @param element
         */
        edit: function (element) {
            var partId = $(element).data('part-id');
            var url = window.location.href.replace('/form-config/', '/form-config/grid-edit/') + '?_ch=' + $('#_ch').val() + '&paId=' + partId;

            $(document).load(url, function (form) {
                Lemo_Modal
                    .setId('modal-container-formconfig-grid-edit')
                    .setTitle('Edit grid')
                    .setContent(form)
                    .setSize('large')
                    .addButton('change', '<i class="fas fa-fw fa-check"></i> ' + translate('Change'), 'btn btn-primary', function () {
                        $.ajax({
                            type: 'post',
                            url: url,
                            data: $('#formConfigGrid').find(':input').serialize(),
                            dataType: "json",
                            success: function (data) {
                                $(element).find('ul.el-' + DynaCore_FormConfig_Grid.partName + '-fieldGrid-container').html('');
                                $(element).find('ul.el-' + DynaCore_FormConfig_Grid.partName + '-fieldModal-container').html('');
                                $(element).find('ul.el-' + DynaCore_FormConfig_Grid.partName + '-fieldSection-container').html('');

                                var elFieldGridContainer = $(element).find('ul.el-' + DynaCore_FormConfig_Grid.partName + '-fieldGrid-container');
                                var elFieldModalContainer = $(element).find('ul.el-' + DynaCore_FormConfig_Grid.partName + '-fieldModal-container');
                                var elFieldSectionContainer = $(element).find('ul.el-' + DynaCore_FormConfig_Grid.partName + '-fieldSection-container');

                                $(elFieldGridContainer).html('');
                                $('#grids-fieldsGrid').find('> .btn').each(function (i, el) {
                                    $(elFieldGridContainer).append('<li class="el el-' + DynaCore_FormConfig_Grid.partName + '-fieldGrid btn btn-sm btn-outline-dark" data-part-id="' + $(el).data('field-id') + '" data-part-index="' + $(el).data('field') + '">' + $(el).text() + '</li>');
                                });

                                $(elFieldModalContainer).html('');
                                $('#grids-fieldsModal').find('> .btn').each(function (i, el) {
                                    $(elFieldModalContainer).append('<li class="el el-' + DynaCore_FormConfig_Grid.partName + '-fieldModal btn btn-sm btn-outline-dark" data-part-id="' + $(el).data('field-id') + '" data-part-index="' + $(el).data('field') + '">' + $(el).text() + '</li>');
                                });

                                $(elFieldSectionContainer).html('');
                                $('#grids-fieldsSection').find('> .btn').each(function (i, el) {
                                    $(elFieldSectionContainer).append('<li class="el el-' + DynaCore_FormConfig_Grid.partName + '-fieldSection btn btn-sm btn-outline-dark" data-part-id="' + $(el).data('field-id') + '" data-part-index="' + $(el).data('field') + '">' + $(el).text() + '</li>');
                                });

                                Lemo_Alert.addSuccess('Grid has been successfully updated', 'formConfigGridEditSuccess');
                                Lemo_Modal.close();
                            },
                            error: function (html) {
                                Lemo_Alert.addDanger('Some form fields are not filled up or not filled correctly', 'formConfigGridEditError');

                                $('#dialogBody').html(html.responseText);
                            }
                        });
                    })
                    .addButton('cancel', '<i class="fas fa-fw fa-times"></i> ' + translate('Cancel'), 'btn btn-secondary', function () {
                        Lemo_Modal.close();
                    });

                Lemo_Modal.build();

                // Inicializace
                DynaCore_FormConfig_Grid.editInit();
                DynaCore_FormConfig.fieldsInit('fieldsGrid', 'grids', partId);
                DynaCore_FormConfig.fieldsInit('fieldsModal', 'grids', partId);
                DynaCore_FormConfig.fieldsInit('fieldsSection', 'grids', partId);
                DynaBase_Tabs.init();
            });
        },

        /**
         * Zmena gridu behem upraveni objektu typu Grid
         */
        editInit: function () {
            // Zmena gridu
            var formConfigGrid = $("#formConfigGrid");
            formConfigGrid
                .off('change', '#modalId')
                .on('change', '#modalId', function () {
                    if (this.value == '') {
                        $('#formConfigGrid').find('.nav-tabs > li:eq(7)').addClass('d-none');
                    } else {
                        formConfigGrid.find('.nav-tabs > li:eq(7)').removeClass('d-none');

                        var storageId = formConfigGrid.find('.tab-content').data('part-id');

                        DynaCore_FormConfig.fieldsLoad(this, 'fieldsModal', 'grids', storageId);
                    }

                    return false;
                });

            // Mazani poli patternu
            formConfigGrid
                .off('keyup', '#pattern')
                .on('keyup', '#pattern', function () {
                    var countPattern = (this.value.match(/%s/g) || []).length;
                    var countFields = $('.patternField').length;
                    var countDiff = (countPattern - countFields);

                    if (countPattern > countFields) {
                        for (var i = 1; i <= countDiff; i++) {
                            DynaCore_FormConfig_Grid.editPatternFieldAdd();
                        }
                    }
                    if (countPattern < countFields) {
                        DynaCore_FormConfig_Grid.editPatternFieldDelete();
                    }

                    // Zadne hodnoty v paternu, vymazeme vsechna pole
                    if (0 == countPattern) {
                        DynaCore_FormConfig_Grid.editPatternFieldsDelete();
                    }
                });

            // Zmena relace
            formConfigGrid
                .off('change', '#relationId')
                .on('change', '#relationId', function () {
                    if (this.value > 0) {
                        formConfigGrid.find('#form-group-pattern').removeClass('d-none');
                        formConfigGrid.find('#form-group-modalId').addClass('d-none');

                        DynaCore_FormConfig_Grid.editPatternFieldsDelete();
                    } else {
                        formConfigGrid.find('#form-group-pattern').addClass('d-none');
                        formConfigGrid.find('#form-group-modalId').removeClass('d-none');
                    }

                    return false;
                });

            // Zmena typu relace
            formConfigGrid
                .off('change', '#type')
                .on('change', '#type', function () {
                    DynaCore_FormConfig_Grid.editPatternFieldsDelete();

                    formConfigGrid.find('#form-group-modalId').addClass('d-none');
                    formConfigGrid.find('#form-group-pattern').addClass('d-none');
                    formConfigGrid.find('#form-group-relationId').addClass('d-none');
                    formConfigGrid.find('#form-group-targetFieldId').addClass('d-none');
                    formConfigGrid.find('#form-group-targetGridId').addClass('d-none');
                    formConfigGrid.find('#form-group-targetSectionId').addClass('d-none');
                    formConfigGrid.find('#modalId').val('');
                    formConfigGrid.find('#pattern').val('');
                    formConfigGrid.find('#plugin').val('');
                    formConfigGrid.find('#pluginMethod').val('');
                    formConfigGrid.find('#pluginMethod').prop('disabled', true).attr('disabled', true);
                    formConfigGrid.find('#relationId').val('');
                    formConfigGrid.find('#targetFieldId').val('');
                    formConfigGrid.find('#targetGridId').val('');
                    formConfigGrid.find('#targetSectionId').val('');
                    formConfigGrid.find('.nav-tabs > li:eq(5)').addClass('d-none');
                    formConfigGrid.find('.nav-tabs > li:eq(6)').addClass('d-none');
                    formConfigGrid.find('.nav-tabs > li:eq(7)').addClass('d-none');

                    if ('field' == this.value) {
                        $('#formConfigGrid').find('#form-group-targetSectionId').removeClass('d-none');
                    }
                    if ('plugin' == this.value) {
                        formConfigGrid.find('#form-group-targetGridId').removeClass('d-none');
                        formConfigGrid.find('#form-group-plugin').removeClass('d-none');
                        formConfigGrid.find('#form-group-pluginMethod').removeClass('d-none');
                    }
                    if ('table' == this.value) {
                        $('#formConfigGrid').find('#form-group-targetSectionId').removeClass('d-none');
                    }
                });

            // Zmena ciloveho pole
            formConfigGrid
                .off('change', '#targetFieldId')
                .on('change', '#targetFieldId', function () {
                    formConfigGrid.find('#form-group-pattern').addClass('d-none');

                    if (this.value > 0) {
                        $('#formConfigGrid').find('#form-group-pattern').removeClass('d-none');
                    }
                });

            // Zmena cilove sekce
            formConfigGrid
                .off('change', '#targetGridId')
                .on('change', '#targetGridId', function () {
                    var type = formConfigGrid.find('#type').val();

                    if (this.value > 0) {
                        var storageId = formConfigGrid.find('.tab-content').data('part-id');

                        DynaCore_FormConfig.fieldsLoad(this, 'fieldsGrid', 'grids', storageId);

                        formConfigGrid.find('.nav-tabs > li:eq(6)').removeClass('d-none');
                    } else {
                        formConfigGrid.find('.nav-tabs > li:eq(6)').addClass('d-none');
                    }
                });

            // Zmena cilove sekce
            formConfigGrid
                .off('change', '#targetSectionId')
                .on('change', '#targetSectionId', function () {
                    var type = formConfigGrid.find('#type').val();

                    formConfigGrid.find('#form-group-targetFieldId').addClass('d-none');
                    formConfigGrid.find('#form-group-relationId').addClass('d-none');
                    formConfigGrid.find('#form-group-pattern').addClass('d-none');

                    if (this.value > 0) {
                        var storageId = formConfigGrid.find('.tab-content').data('part-id');

                        DynaCore_FormConfig_Grid.editPatternSectionChanged(this);

                        formConfigGrid.find('.nav-tabs > li:eq(6)').removeClass('d-none');

                        if ('field' == type) {
                            DynaCore_Field.loadToElement(formConfigGrid.find('#targetFieldId'), 'section', this.value);
                            formConfigGrid.find('#form-group-targetFieldId').removeClass('d-none');
                        }
                        if ('table' == type) {
                            formConfigGrid.find('#form-group-relationId').removeClass('d-none');
                            formConfigGrid.find('#form-group-modalId').removeClass('d-none');

                            $.ajax({
                                type: 'get',
                                url: window.location.href.replace('/form-config/', '/form-config/load-section-relations/'),
                                data: {_ch: $('#_ch').val(), i: this.value},
                                dataType: 'json',
                                success: function (data) {
                                    // Remove existing options
                                    $('#formConfigGrid').find('#relationId').find('option').not(':first').remove();

                                    // Append new options
                                    $.each(data, function (i, item) {
                                        $('#formConfigGrid').find('#relationId').append($('<option value="' + item.i + '">' + item.n + '</option>'));
                                    });
                                }
                            });
                        }
                    } else {
                        $('#formConfigGrid').find('.nav-tabs > li:eq(6)').addClass('d-none');
                    }
                });

            // Vyber pluginu
            formConfigGrid
                .off('change', '#plugin')
                .on('change', '#plugin', function () {
                    if (this.value > 0) {
                        $.ajax({
                            type: 'get',
                            url: '/core/form-config/load-plugin-actions/',
                            data: {_ch: $('#_ch').val(), id: this.value},
                            dataType: 'json',
                            beforeSend: function () {
                                $('#formConfigGrid').find('#pluginMethod').prop('disabled', true).attr('disabled', true);
                            },
                            success: function (data) {
                                formConfigGrid.find('#pluginMethod').find('option').not(':first').remove();

                                // Append new options
                                $.each(data, function (i, item) {
                                    $('#formConfigGrid').find('#pluginMethod').append($('<option value="' + item.i + '">' + item.n + '</option>'));
                                });

                                if (formConfigGrid.find('#pluginMethod > option').length > 1) {
                                    $('#formConfigGrid').find('#pluginMethod').prop('disabled', false).attr('disabled', false);
                                }
                            }
                        });
                    } else {
                        $('#formConfigGrid').find('#pluginMethod').prop('disabled', true).attr('disabled', true);
                    }
                });
        },

        /**
         * Upraveni pole gridu
         *
         * @param element
         */
        editField: function (element) {
            var gridId = $(element).parents('.tab-content').data('part-id');
            var fieldIndex = $(element).data('field');
            var target = $(element).data('target');
            var url = window.location.href.replace('/form-config/', '/form-config/grid-edit-field/') + '?_ch=' + $('#_ch').val() + '&griId=' + gridId + '&fieInd=' + fieldIndex + '&tar=' + target;

            $(document).load(url, function (form) {
                Lemo_Modal
                    .setId('modal-container-formconfig-grid-field-edit')
                    .setTitle('Edit grid field')
                    .setContent(form)
                    .setSize('large')
                    .addButton('change', '<i class="fas fa-fw fa-check"></i> ' + translate('Change'), 'btn btn-primary', function () {
                        $.ajax({
                            type: 'post',
                            url: url,
                            data: $('#formConfigGridField').find(':input').serialize(),
                            dataType: "json",
                            success: function () {
                                Lemo_Modal.close();
                            },
                            error: function (html) {
                                Lemo_Alert.addDanger('Some form fields are not filled up or not filled correctly', 'formConfigGridFieldUpdateError');

                                $('#dialogBody').html(html.responseText);
                            }
                        });
                    })
                    .addButton('cancel', '<i class="fas fa-fw fa-times"></i> ' + translate('Cancel'), 'btn btn-secondary', function () {
                        Lemo_Modal.close();
                    });

                Lemo_Modal.build();

                DynaBase_Overlay.hide();
            });
        },

        /**
         * Pridani pole patternu
         */
        editPatternFieldAdd: function () {
            var formConfigGrid = $('#formConfigGrid');
            var span = formConfigGrid.find('#form-template-fieldsPattern');
            var template = $(span).attr('data-template');
            var count = formConfigGrid.find('.patternField').length;

            template = template.replace(/__index__/g, count);

            if (count == 0) {
                $.ajax({
                    type: 'get',
                    url: '/core/field/load-fields',
                    data: {_ch: $('#_ch').val(), ta: 'section', taId: formConfigGrid.find('#targetSectionId').val()},
                    dataType: 'json',
                    beforeSend: function () {
                        formConfigGrid.find('#pattern').prop('disabled', true).attr('disabled', true);
                    },
                    complete: function () {
                        formConfigGrid.find('#pattern').prop('disabled', false).attr('disabled', false).focus();
                    },
                    success: function (data) {

                        // Parse HTML
                        template = $.parseHTML(template);

                        // Remove existing options
                        $(template).find('option').not(':first').remove();

                        // Append new options
                        $.each(data, function (i, item) {
                            $(template).find('select').append($('<option value="' + item.i + '">' + item.n + '</option>'));
                        });

                        $(span).before($(template)[0].outerHTML);
                        $(span).before($(template)[1].outerHTML);
                    }
                });
            } else {
                var options = formConfigGrid.find('.patternField').first().html();
                $(span).before(template);
                formConfigGrid.find('.patternField').last().html(options).prop('selectedIndex', 0);
            }
        },

        /**
         * Smazani pole patternu
         */
        editPatternFieldDelete: function () {
            $('#formConfigGrid').find('.patternField').last().parents('.form-group').remove();
        },

        /**
         * Smazani vsech poli patternu
         */
        editPatternFieldsDelete: function () {
            $('#formConfigGrid').find('.patternField').parents('.form-group').remove();
        },

        /**
         * Zmena sekce
         *
         * @param element
         */
        editPatternSectionChanged: function (element) {
            var formConfigGrid = $('#formConfigGrid');
            formConfigGrid.find('#pattern').val('');
            DynaCore_FormConfig_Grid.editPatternFieldsDelete();

            if ($(element).val() > 0) {
                formConfigGrid.find('#form-group-pattern').removeClass('d-none');
            } else {
                formConfigGrid.find('#form-group-pattern').addClass('d-none');
            }
        },

        /**
         * Smazani objektu typu Grid
         *
         * @param element
         */
        delete: function (element) {
            var indexRow = $(element).data('row');
            var indexCol = $(element).data('col');
            var indexTab = $(element).data('tab');
            var indexTabRow = $(element).data('tab-row');
            var indexTabCol = $(element).data('tab-col');
            var partId = $(element).data('part-id');
            var partIndex = $(element).data('part-index');

            Lemo_Modal
                .setId('modal-container-formconfig-grid-delete')
                .setTitle('Remove grid')
                .setContent('<p class="text">' + translate('Do you really want to remove selected grid?') + '</p>')
                .addButton('remove', '<i class="fas fa-fw fa-trash"></i> ' + translate('Remove'), 'btn btn-danger', function () {
                    $.ajax({
                        type: 'get',
                        url: window.location.href.replace('/form-config/', '/form-config/part-delete/'),
                        data: {
                            _ch: $('#_ch').val(),
                            pa: DynaCore_FormConfig_Grid.partName,
                            r: indexRow,
                            c: indexCol,
                            t: indexTab,
                            tr: indexTabRow,
                            tc: indexTabCol,
                            paIn: partIndex,
                            paId: partId
                        },
                        dataType: "json",
                        success: function () {
                            if ($(element).parent('.card-body').parent(DynaCore_FormConfig_Grid.partSelector + '-card').length > 0) {
                                element = $(element).parent('.card-body').parent(DynaCore_FormConfig_Grid.partSelector + '-card');
                            }

                            $(element).remove();

                            DynaCore_FormConfig.reindex();
                        },
                        complete: function () {
                            Lemo_Modal.close();
                        }
                    });
                })
                .addButton('cancel', '<i class="fas fa-fw fa-times"></i> ' + translate('Cancel'), 'btn btn-secondary', function () {
                    Lemo_Modal.close();
                });

            Lemo_Modal.build();
        }
    }
}